<!-- Translated: skip -->
<template>
    <div :class="'notification ' + colorClass + ' ' + alignClass" role="note">
        <div :class="'flexer' + (icon ? ' has-icon' : '')">
          <Icon v-if="icon" :name="icon" scale="1.2" />
          <div class="content">
            <component :is="elementTag" v-if="title">{{ title }}</component>
            <slot></slot>
          </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/components/Icon';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    align: {
      type: String,
      default: 'center',
    },
    color: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: 'strong',
    },
    icon: {
      type: String,
      default: '',
    },
  },
  components: {
    Icon,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
  computed: {
    colorClass() {
      if (this.color === 'blue') {
        return 'notification--blue';
      }
      if (this.color === 'white') {
        return 'notification--white';
      }
      if (this.color === 'warning') {
        return 'notification--warning';
      }

      return '';
    },
    alignClass() {
      if (this.align === 'center') {
        return 'center';
      }

      return '';
    },
    elementTag() {
      return this.tag;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.notification
  info-box()

  &.notification--blue
    info-box--blue()

  &.notification--white
    info-box--white()

  &.notification--warning
    info-box--warning()
  
  .flexer
    display flex
    .icon
      width: 2rem
    .content
      flex: 1
      padding-left: 1rem
      padding-right: 0rem
</style>



// WEBPACK FOOTER //
// Note.vue?03c83972